// Avatar colors palette matching design — used across the app
export const AVATAR_COLORS = {
    pink:   { bg: '#FCE7F3', border: '#EC4899', text: '#9D174D', dot: '#EC4899' },
    blue:   { bg: '#DBEAFE', border: '#3B82F6', text: '#1E40AF', dot: '#3B82F6' },
    green:  { bg: '#D1FAE5', border: '#10B981', text: '#065F46', dot: '#10B981' },
    purple: { bg: '#EDE9FE', border: '#8B5CF6', text: '#5B21B6', dot: '#8B5CF6' },
    orange: { bg: '#FFEDD5', border: '#F97316', text: '#9A3412', dot: '#F97316' },
    teal:   { bg: '#CCFBF1', border: '#14B8A6', text: '#115E59', dot: '#14B8A6' },
};

export const AVATAR_COLOR_LIST = ['pink', 'blue', 'green', 'purple', 'orange', 'teal'];

export const FAMILY_ROLES = ['Mamá', 'Papá', 'Hijo', 'Hija', 'Abuelo', 'Abuela', 'Tío', 'Tía', 'Pareja', 'Hermano', 'Hermana', 'Otro'];

export const DOC_TYPES = [
    { value: 'identidad', label: 'Documento de Identidad' },
    { value: 'pasaporte', label: 'Pasaporte' },
    { value: 'licencia', label: 'Licencia de Conducir' },
    { value: 'seguro', label: 'Póliza de Seguro' },
    { value: 'otro', label: 'Otro' },
];

export const CONTACT_CATEGORIES = [
    { value: 'familia', label: 'Familia' },
    { value: 'trabajo', label: 'Trabajo' },
    { value: 'amigos', label: 'Amigos' },
    { value: 'otro', label: 'Otro' },
];

export const BLOOD_TYPES = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-', 'Desconocido'];

export function getInitials(name) {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
}

export function formatDate(iso) {
    if (!iso) return '—';
    try {
        const d = new Date(iso);
        return d.toLocaleDateString('es', { year: 'numeric', month: 'long', day: 'numeric' });
    } catch { return iso; }
}

export function shortDate(iso) {
    if (!iso) return '—';
    try {
        const d = new Date(iso);
        return d.toLocaleDateString('es', { year: 'numeric', month: '2-digit', day: '2-digit' });
    } catch { return iso; }
}

export function yearFromDate(iso) {
    if (!iso) return '';
    try { return new Date(iso).getFullYear(); } catch { return ''; }
}
